<div class="row g-1 m-0" style="height:calc(100vh - 50px);">

	<div class="col-auto d-none d-xxl-block" id="rms_cards" style="width:380px;">

		<div class="card shadow mb-1 mt-lg-0">
			<h5 class="card-header">Eladó terminálok</h5>
			<div class="card-body text-center">

				<div class="row g-2">
					<div class="col">
						<h1><%- terminal_stats.total %></h1>
						<small>jegyzett</small>
					</div>
					<div class="col-5">
						<h1><%- terminal_stats.active_1_week %> <span class="text-secondary">/</span> <span class="text-warning"><%- terminal_stats.total - terminal_stats.active_1_week %></span></h1>
						<small>aktív / inaktív (1 hét)</small>
					</div>
					<div class="col">
						<h1><span class="text-success"><%- terminal_stats.active_5_mins %></span></h1>
						<small>aktív (5 perc)</small>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-end">
					<a class="btn btn-dark" href="/c_order/terminal/list"><i class="fa fa-search me-2"></i>Teljes lista</a>
				</div>
			</div>
		</div>

		<div class="card shadow mb-1">
			<h5 class="card-header">NTAK jelentés beállítások (windows)</h5>
			<table class="table table-dark w-100 text-end" style="margin-top:1px; margin-bottom:5px;">
				<thead>
					<tr>
						<th class="text-start ps-3">kliens programban <i class="fa fa-long-arrow-alt-right"></i></th>
						<!--<th>ismeretlen</th>-->
						<th>inaktív</th>
						<th>készül</th>
						<th class="pe-3">éles</th>
					</tr>
				</thead>
				<tbody class="text-strong text-primary">
					<tr>
						<th class="text-start ps-3">érvényes tanúsítvány</th>
						<!--<td class="<% if (ntak_stats.good_cert_unkn > 0) { %>text-warning<% } %>"><%= ntak_stats.good_cert_unkn %></td>-->
						<td class="<% if (ntak_stats.good_cert_off > 0) { %>text-danger<% } %>"><%= ntak_stats.good_cert_off %></td>
						<td class="<% if (ntak_stats.good_cert_prepare > 0) { %>text-warning<% } %>"><%= ntak_stats.good_cert_prepare %></td>
						<td class="pe-3 text-success"><%= ntak_stats.good_cert_on %></td>
					</tr>
					<tr>
						<th class="text-start ps-3">lejárt / sandbox tanúsítvány</th>
						<!--<td class="<% if (ntak_stats.bad_cert_unkn > 0) { %>text-danger<% } %>"><%= ntak_stats.bad_cert_unkn %></td>-->
						<td class="<% if (ntak_stats.bad_cert_off > 0) { %>text-danger<% } %>"><%= ntak_stats.bad_cert_off %></td>
						<td class="<% if (ntak_stats.bad_cert_prepare > 0) { %>text-warning<% } %>"><%= ntak_stats.bad_cert_prepare %></td>
						<td class="pe-3 <% if (ntak_stats.bad_cert_on > 0) { %>text-danger<% } %>"><%= ntak_stats.bad_cert_on %></td>
					</tr>
					<tr>
						<th style="border-bottom-width:0;" class="text-start ps-3">nincs tanúsítvány</th>
						<!--<td style="border-bottom-width:0;"><%= ntak_stats.no_cert_unkn %></td>-->
						<td style="border-bottom-width:0;"><%= ntak_stats.no_cert_off %></td>
						<td style="border-bottom-width:0;" class="<% if (ntak_stats.no_cert_prepare > 0) { %>text-warning<% } %>"><%= ntak_stats.no_cert_prepare %></td>
						<td style="border-bottom-width:0;" class="pe-3 <% if (ntak_stats.no_cert_on > 0) { %>text-danger<% } %>"><%= ntak_stats.no_cert_on %></td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="card shadow mb-1">
			<h5 class="card-header">Pénztárgépek</h5>
			<div class="card-body text-center">

				<div class="row g-2">
					<div class="col-6">
						<h1><%- aees.data.length %></h1>
						<small>nyilvántarott pénztárgép</small>
					</div>
					<div class="col-6">
						<h1><%- operated_aees.length %></h1>
						<small>általunk kezelt pénztárgép</small>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-end">
					<a class="btn btn-dark" href="/c_order/aee/list"><i class="fa fa-search me-2"></i>Teljes lista</a>
				</div>
			</div>
		</div>

		<div class="card shadow">
			<h5 class="card-header">Éves felülvizsgálatok esedékessége</h5>
			<div class="card-body text-center">
				<div class="row g-2">
					<div class="col-3">
						<% if (aee_inspection.overdue > 0) { %>
							<h1 class="text-danger"><i class="fa fa-sm fa-exclamation-circle me-2" style="animation:flash 1s infinite;"></i><%- aee_inspection.overdue %></h1>
						<% } else { %>
							<h1><%- aee_inspection.overdue %></h1>
						<% } %>
						<small>lejárt</small>
					</div>
					<div class="col-3">
						<h1 class="<% if (aee_inspection.due_1_week > 0) { %>text-danger<% } %>"><%- aee_inspection.due_1_week %></h1>
						<small>&lt; 1 hét</small>
					</div>
					<div class="col-3">
						<h1 class="<% if (aee_inspection.due_1_month > 0) { %>text-warning<% } %>"><%- aee_inspection.due_1_month %></h1>
						<small>&lt; 1 hónap</small>
					</div>
					<div class="col-3">
						<h1><%- aee_inspection.due_3_months %></h1>
						<small>&lt; 3 hónap</small>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-end">
					<a class="btn btn-dark" href="/c_order/aee/list?operator_service_id=145&sort_order=7a"><i class="fa fa-search me-2"></i>Felülvizsgálatok lista</a>
				</div>
			</div>
		</div>
	</div>

	<div class="col" id="user_issues">
		<div class="card shadow">
			<h5 class="card-header">Teendők</h5>
			<div class="card-body">

				<%- include('/ui/grid', {
					name: 'issue',
					params: {
						row_height: 28.5,
						columns: [
							{
								title: 'Hozzáadva',
								field: 'insert_dt',
								type: 'datetime',
								width: 150
							},
							{
								title: 'P.',
								field: 'priority_tag',
								type: {
									render (value, row, data, params) {

										if (!value) return ''

										const tag = Anvil.page.issue_tags.getById(value)
										if (tag.type != 'priority') return undefined
										if (tag.icon) {
											return `<span class="badge text-dark" title="${tag.name}" style="background-color:${tag.color};"><i class="${tag.icon} fa-fw"></i></span>`
										} else {
											return `<span class="badge text-dark" style="background-color:${tag.color};">${tag.name}</span>`
										}
									}
								},
								options: {
									class: 'text-center'
								},
								width: 50
							},
							{
								title: 'T.',
								field: 'work_tags',
								type: {
									render (value, row, data, params) {

										// Tags
										let tags_html = ''
										if (Array.isArray(row.work_tags)) {
											tags_html = row.work_tags.map(tid => {
												const tag = Anvil.page.issue_tags.getById(tid)
												if (tag.type != 'work') return undefined
												if (tag.icon) {
													return `<span class="badge text-dark" title="${tag.name}" style="background-color:${tag.color};"><i class="${tag.icon} fa-fw"></i></span>`
												} else {
													return `<span class="badge text-dark" style="background-color:${tag.color};">${tag.name}</span>`
												}
											}).filter(Boolean).join(' ')
										}

										return tags_html
									}
								},
								options: {
									class: 'text-center'
								},
								width: 60
							},
							{
								title: 'Téma',
								field: 'title',
								type: {
									render (value, row, data, params) {

										// Tags
										let tags_html = ''
										if (Array.isArray(row.tags) && row.tags.length > 0) {
											tags_html = row.tags.map(tid => {
												const tag = Anvil.page.issue_tags.getById(tid)
												if (tag.type != 'project') return undefined
												if (tag.icon) {
													return `<span class="badge text-dark" title="${tag.name}" style="background-color:${tag.color};"><i class="${tag.icon} fa-fw"></i></span>`
												} else {
													return `<span class="badge text-dark" style="background-color:${tag.color};">${tag.name}</span>`
												}
											}).filter(Boolean).join(' ')
										}

										if (row.closed) {
											return `${tags_html} <span class="text-success">${value}</span>`
										} else if (row.responsible_user_id == Anvil.session.user.id) {
											return `${tags_html} <strong>${value}</strong>`
										} else {
											return `${tags_html} <span>${value}</span>`
										}
									}
								},
								width: 400
							},
							{
								title: 'L.',
								field: 'user_view_dt',
								type: {
									render (value, row, data, params) {
										const issue_updated_dt = row.update_dt || row.insert_dt
										if (row.user_view_dt && Anvil.moment(row.user_view_dt).isSameOrAfter(issue_updated_dt)) {
											// Seen
											return ''
										} else {
											// Unseen
											return '<i class="fas fa-fw fa-star text-gold"></i>'
										}
									}
								},
								options: {
									class: 'text-center'
								},
								width: 50
							},
							{
								title: 'Társított entitás',
								field: 'link',
								type: {
									render (value, row, data, params) {
										let entity_chain = []

										if (['company', 'database', 'site', 'terminal', 'aee'].includes(value)) {
											const company = Anvil.page.companies.data.find(c => c.id == row.company_id)
											entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('company/modal_edit', ${row.company_id})"><i class="fa fa-fw fa-sm fa-building me-1"></i>` + (company?.name || '[ismeretlen cég]') + '</div>')
											if (['database', 'site', 'terminal', 'aee'].includes(value)) {
												const company_db = Anvil.page.company_dbs.data.find(c => c.id == row.company_db_id)
												entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/company_db/modal_edit', ${row.company_db_id})"><i class="fa fa-fw fa-sm fa-database me-1"></i>` + (company_db?.db_name || '[ismeretlen adatbázis]') + '</div>')
												if (['site', 'terminal', 'aee'].includes(value)) {
													const site = Anvil.page.sites.data.find(s => s.company_db_id == row.company_db_id && s.id == row.site_id)
													entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/site/modal_edit', ${row.company_db_id}, ${row.site_id})"><i class="fa fa-fw fa-sm fa-map-marker me-1"></i>` + (site?.public_name || site?.name || '[ismeretlen telephely]') + '</div>')
													if (['terminal', 'aee'].includes(value)) {
														const terminal = Anvil.page.terminals.data.find(t => t.machine_id == row.terminal_id)
														entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/terminal/modal_edit', ${row.company_id}, '${row.terminal_id}')"><i class="fa fa-fw fa-sm fa-desktop me-1"></i>` + (terminal?.device_info?.hostname || '[ismeretlen terminál]') + '</div>')
														if (['aee'].includes(value)) {
															const aee = Anvil.page.aees.data.find(a => a.id == row.aee_id)
															entity_chain.push(`<div class="link-entity" onclick="Anvil.exec('c_order/aee/modal_edit', ${row.aee_id})"><i class="fa fa-fw fa-sm fa-cash-register me-1"></i>` + (aee?.ap || '[ismeretlen pénztárgép]') + '</div>')
														}
													}
												}
											}
										} else {
											entity_chain.push('<span class="text-muted">Nincs</span>')
										}

										return entity_chain.join('<span style="color:black;"><i class="fa fa-fw fa-sm fa-caret-right"></i></span>')
									}
								},
								width: 400
							}
						]
					},
					list: issues
				}) %>

			</div>
			<div class="card-footer">
				<div class="float-end">
					<button class="btn btn-success" onclick="Anvil.page.new_issue()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új munkalap</span></button>
					<a class="btn btn-dark" href="/issue/list?sort_order=&responsible_user_id=<%- Anvil.session.user.id %>"><i class="fa fa-search me-2"></i>Részletes lista (saját)</a>
				</div>
			</div>
		</div>
	</div>

	<div class="col-auto d-none d-xl-block" id="rms_versions" style="width:320px;">
		<div class="card shadow">
			<h5 class="card-header">c-Order verziók</h5>
			<div class="card-body">
				<strong>Telepített verziók</strong><br />
				<%- include('/ui/chart', {
					params: {
						type: 'doughnut',
						data: {
							labels: [
								'Ismeretlen',
								'Kiadatlan',
								'Alfa',
								'Béta',
								'Stabil',
								'Elavult',
								'Egyéb'
							],
							datasets: [{
								label: 'Terminálok száma',
								data: [
									version_stats.reduce((x, v) => v[1].state == 'indeterminate' ? x + v[1].count : x, 0),
									version_stats.reduce((x, v) => v[1].state == 'unpublished' ? x + v[1].count : x, 0),
									version_stats.reduce((x, v) => v[1].state == 'alpha' ? x + v[1].count : x, 0),
									version_stats.reduce((x, v) => v[1].state == 'beta' ? x + v[1].count : x, 0),
									version_stats.reduce((x, v) => v[1].state == 'stable' ? x + v[1].count : x, 0),
									version_stats.reduce((x, v) => v[1].state == 'deprecated' ? x + v[1].count : x, 0),
									version_stats.reduce((x, v) => v[1].state == 'invalid' ? x + v[1].count : x, 0)
								],
								backgroundColor: [
									'rgb(173, 181, 189)',
									'rgb(0, 0, 0)',
									'rgb(199, 28, 34)',
									'rgb(221, 86, 0)',
									'rgb(115, 168, 57)',
									'rgb(47, 164, 231)',
									'rgb(3, 60, 115)'
								],
								borderColor: 'rgb(62, 68, 74)',
								hoverOffset: 4
							}]
						},
						options: {
							aspectRatio: 1.6,
							plugins: {
								legend: {
									position: 'right',
									labels: {
										color: 'rgb(166, 172, 178)'
									}
								}
							}
						}
					}
				}) %>

				<strong>Frissítési csatornák</strong><br />
				<%- include('/ui/chart', {
					params: {
						type: 'doughnut',
						data: {
							labels: [
								'Alfa',
								'Béta',
								'Stabil',
								'Ne frissüljön'
							],
							datasets: [{
								label: 'Terminálok száma',
								data: [
									version_channel_stats.alpha,
									version_channel_stats.beta,
									version_channel_stats.stable,
									version_channel_stats.disabled
								],
								backgroundColor: [
									'rgb(199, 28, 34)',
									'rgb(221, 86, 0)',
									'rgb(115, 168, 57)',
									'rgb(173, 181, 189)'
								],
								borderColor: 'rgb(62, 68, 74)',
								hoverOffset: 4
							}]
						},
						options: {
							aspectRatio: 2.42,
							plugins: {
								legend: {
									position: 'left',
									labels: {
										color: 'rgb(166, 172, 178)'
									}
								}
							}
						}
					}
				}) %>
			</div>
			<table class="table table-dark w-100 mb-0 text-end" style="margin-top:1px;">
				<thead>
					<tr>
						<th class="text-start ps-3">verzió</th>
						<th style="width:65px;">példány</th>
						<th style="width:100px;"></th>
						<th class="pe-3" style="width:65px;">hányad</th>
					</tr>
				</thead>
			</table>
			<div style="max-height:calc(100vh - 597px); overflow-y:auto; margin-bottom:5px;">
				<table class="table table-dark table-sm w-100 text-end m-0">
					<tbody class="text-strong text-primary">
						<% for (const ver of version_stats) { %>
						<tr>
							<th class="text-start ps-3 text-<%- Anvil.models.c_order.Versions.colors[ver[1].state] %>"><%= ver[0] %></th>
							<td class="text-<%- Anvil.models.c_order.Versions.colors[ver[1].state] %>" style="width:65px;"><%= ver[1].count %></td>
							<td style="width:100px;" class="position-relative"><div class="bg-<%- Anvil.models.c_order.Versions.colors[ver[1].state] %> float-end" style="position:absolute; right:0; top:5px; height:18px; border-radius:3px; width:<%= Math.max(3, ver[1].count / terminal_stats.total * 100) %>px;"></div></td>
							<td style="width:65px;" class="pe-3 text-secondary"><%= Anvil.numeral(ver[1].count / terminal_stats.total * 100).format('#.00') %>%</td>
						</tr>
						<% } %>
					</tbody>
				</table>
			</div>
			<% if (versions.data) { %>
			<div class="card-footer px-2">
				<div class="btn-group w-100">
					<a href="https://c-order.eu/releases/<%- versions.data.alpha.path %>" class="btn btn-dark"><i class="fa fa-lg fa-download text-danger mb-2"></i><br /><strong>alfa</strong><br /><%- versions.data.alpha.version %></a>
					<a href="https://c-order.eu/releases/<%- versions.data.beta.path %>" class="btn btn-dark"><i class="fa fa-lg fa-download text-warning mb-2"></i><br /><strong>béta</strong><br /><%- versions.data.beta.version %></a>
					<a href="https://c-order.eu/releases/<%- versions.data.stable.path %>" class="btn btn-dark"><i class="fa fa-lg fa-download text-success mb-2"></i><br /><strong>stabil</strong><br /><%- versions.data.stable.version %></a>
				</div>
			</div>
			<% } %>
		</div>
	</div>

	<!--
	<div class="col-12 col-xl-5">
		<div class="row g-3">

			<div class="col d-none d-xl-block" id="panel-server-traffic">
				<-%- include('/main/panel_server_traffic', { stat_date, stat_log }) %->
			</div>

		</div>
	</div>
	-->
</div>


<script>
Object.assign(Anvil.page, {

	refresh () {
		Anvil.exec('main/action_refresh')
	},

	new_issue () {
		Anvil.exec('issue/modal_edit')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#issue_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('issue/modal_edit', sel[0].id)
		}
	}
})

$('#issue_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>